/** OpenFreeMap serves vector tiles only — there is no raster fallback.
 *  Styles are public and keyless. */
export enum MapStyleName {
  Positron = 'positron',
  Dark = 'dark',
}

const OPENFREEMAP_STYLE_BASE = 'https://tiles.openfreemap.org/styles';

export function mapStyleUrl(style: MapStyleName): string {
  return `${OPENFREEMAP_STYLE_BASE}/${style}`;
}

export function mapStyleForTheme(isDark: boolean): MapStyleName {
  return isDark ? MapStyleName.Dark : MapStyleName.Positron;
}

/** OpenFreeMap's required attribution, credited to all three sources the
 *  OpenMapTiles terms and the ODbL require. The OSM credit uses the
 *  ODbL-canonical "© OpenStreetMap contributors" phrasing — the licence names
 *  the contributors as the rights holders, so a looser "Data from
 *  OpenStreetMap" is not a compliant credit. This string must render on every
 *  map, undismissed. */
export const MAP_ATTRIBUTION_TEXT =
  'OpenFreeMap · © OpenMapTiles · © OpenStreetMap contributors';

export interface MapBounds {
  minLat: number;
  minLon: number;
  maxLat: number;
  maxLon: number;
}

export interface MapPoint {
  lat: number;
  lon: number;
}

/** Auto-fit bounds across points. Returns null for an empty set so the
 *  caller can fall back to its single-pin framing. */
export function boundsForPoints(points: MapPoint[]): MapBounds | null {
  if (points.length === 0) {
    return null;
  }

  return points.reduce<MapBounds>(
    (bounds, point) => ({
      minLat: Math.min(bounds.minLat, point.lat),
      minLon: Math.min(bounds.minLon, point.lon),
      maxLat: Math.max(bounds.maxLat, point.lat),
      maxLon: Math.max(bounds.maxLon, point.lon),
    }),
    {
      minLat: points[0].lat,
      minLon: points[0].lon,
      maxLat: points[0].lat,
      maxLon: points[0].lon,
    },
  );
}
